<script>
    import { onMount } from "svelte";
    import Conexoes from "../../Classes/Conexoes";
    import Constantes from "../../Classes/Constantes";
    import { Paper } from "@svelteuidev/core";
    import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
    import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
    import { DadosLogin } from "../../Classes/Stores";

    const conexao = new Conexoes();

    export let id_assessoria = 1;//lembrar de puxar lógica aqui
    export let id_usuario =  $DadosLogin.id_usuario;
    export let resultado = [];
    export let ReadOnly=false;
    let respostas = {};
    let erros = {};
    let message;
    let isLoading = false;
    let respostasAnteriores = [];
    let verAnterior = [];
    async function PegaDados() {
        isLoading = true;
        resultado = await conexao.conecta("retorna_formularios.php", {
            id_usuario: id_usuario,
            id_assessoria:id_assessoria,
        });

        // Processar respostas agrupadas por pergunta
        resultado.forEach((formulario) => {
            formulario.quesitos.forEach((quesito) => {
                if (quesito.respostas) {
                    respostasAnteriores[quesito.id_quesito] = quesito.respostas.split('|');
                    console.log("aqui", quesito.id_quesito);
                    console.log(quesito.respostas);
                }
                if (quesito.resposta) {
                    respostas[quesito.id_quesito] = quesito.resposta;
                }
            });
        });

        console.log(respostasAnteriores);
        isLoading = false;
    }

    function groupBy(array, key) {
        return array.reduce((result, item) => {
            (result[item[key]] = result[item[key]] || []).push(item);
            return result;
        }, {});
    }

    function handleInputChange(event, idQuesito, obrigatorio) {
        const { value } = event.target;
        respostas[idQuesito] = value;
        if (obrigatorio && !value) {
            erros[idQuesito] = true;
        } else {
            delete erros[idQuesito];
        }
    }

    function handleRadioChange(event, idQuesito, obrigatorio) {
        const { value } = event.target;
        respostas[idQuesito] = value;
        if (obrigatorio && !value) {
            erros[idQuesito] = true;
        } else {
            delete erros[idQuesito];
        }
    }

    function validarRespostas() {
        resultado.forEach((formulario) => {
            formulario.quesitos.forEach((quesito) => {
                if (
                    quesito.obrigatorio == 1 &&
                    !respostas[quesito.id_quesito]
                ) {
                    erros[quesito.id_quesito] = true;
                }
            });
        });
    }

    async function enviarRespostas() {
        validarRespostas();

        // Verifica se há erros antes de enviar
        let hasError = false;
        for (let quesito of Object.keys(erros)) {
            if (erros[quesito]) {
                hasError = true;
                break;
            }
        }
        if (hasError) {
            message = Constantes.msg_campos_obrigatorios;
            return;
        }

        let result = await conexao.conecta("armazenar_respostas.php", {
            respostas: respostas,
            id_usuario: $DadosLogin.id_usuario,
        }, true);

        //message = result.message; // exibe a mensagem de sucesso ou erro
    }

    onMount(() => {
        PegaDados();
    });
</script>

<LoadingTela {isLoading} />
<CaixaDeDialogo
    {message}
    on:close={() => {
        message = "";
    }}
/>
{#if resultado}
    {#each resultado as formulario}
        <div class="container margens">
            <h2 class="text-center mb-4">{formulario.nome_formulario}</h2>
            {#each Object.entries(formulario.quesitos.reduce((acc, quesito) => {
                    if (!acc[quesito.nome_bloco]) {
                        acc[quesito.nome_bloco] = [];
                    }
                    acc[quesito.nome_bloco].push(quesito);
                    return acc;
                }, {})) as [nome_bloco, quesitos]}
                <Paper class="p-3 mb-4">
                    <h3>{nome_bloco}</h3>
                    {#each quesitos as quesito}
                        <div class="mb-3">
                            <p class="font-weight-bold">
                                {quesito.pergunta}
                                {#if quesito.obrigatorio == 1}<span
                                        class="obrigatorio">*</span
                                    >{/if}
                            </p>
                            {#if quesito.tipo_pergunta === "texto"}
                                <!-- Resposta Recente -->
                                <input
                                    type="text"
                                    class="form-control {erros[
                                        quesito.id_quesito
                                    ]
                                        ? 'erro'
                                        : ''}"
                                    value={respostas[quesito.id_quesito] || ""}
                                    on:input={(event) =>
                                        handleInputChange(
                                            event,
                                            quesito.id_quesito,
                                            quesito.obrigatorio,
                                        )}
                                        readonly={ReadOnly}
                                        disabled={ReadOnly}
                                />

                                
                            {:else if quesito.tipo_pergunta === "alternativa"}
                                {#if quesito.alternativas}
                                    {#each quesito.alternativas.split("|") as alternativa}
                                        <div class="form-check">
                                            <input
                                                type="radio"
                                                class="form-check-input {erros[
                                                    quesito.id_quesito
                                                ]
                                                    ? 'erro'
                                                    : ''}"
                                                name="quesito-{quesito.id_quesito}"
                                                value={alternativa}
                                                checked={respostas[
                                                    quesito.id_quesito
                                                ] === alternativa}
                                                on:change={(event) =>
                                                    handleRadioChange(
                                                        event,
                                                        quesito.id_quesito,
                                                        quesito.obrigatorio,
                                                    )}
                                                    readonly={ReadOnly}
                                                    disabled={ReadOnly}
                                            />
                                            <label class="form-check-label"
                                                >{alternativa}</label
                                            >
                                        </div>
                                    {/each}

                                   
                                {/if}
                            {/if}
                            {#if respostasAnteriores[quesito.id_quesito]}
                                    <a
                                       
                                        on:click={() => {
                                            if (
                                                verAnterior[quesito.id_quesito]
                                                    ? (verAnterior[
                                                          quesito.id_quesito
                                                      ] = false)
                                                    : (verAnterior[
                                                          quesito.id_quesito
                                                      ] = true)
                                            );
                                        }}>Ver respostas anteriores</a
                                    >
                                    {#if verAnterior[quesito.id_quesito]}
                                       <Paper>
                                       {#each respostasAnteriores[quesito.id_quesito] as resp}
                                       {resp}<br>
                                       {/each}
                                       </Paper>
                                    {/if}
                                {/if}
                        </div>
                    {/each}
                </Paper>
            {/each}
            {#if !ReadOnly}
            <button class="btn btn-block btn-dark" on:click={enviarRespostas}
                >Responder</button
            >

            {/if}
        </div>
    {/each}
{/if}

<style>
    .obrigatorio {
        color: red;
    }
    .erro {
        border: 1px solid red;
    }
    .margens {
        margin-top: 5em;
        margin-bottom: 4em;
    }
    .texto-riscado {
        text-decoration: line-through;
        color: gray;
    }
    a{
        color:blue;
    }
</style>
